import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectWithDeposit = createSelector(selectJsonQuery, jsonQuery => getTermValue('zalog')(jsonQuery));
